const menuList = (menu, t) => {
  return [
    {
      title: t('home'),
      nivel: 0,
      icon: 'svguse:#icon_home',
      name: 'home',
      href: `/${menu.slug}`,
      show: menu.exibir_home,
    },
    {
      title: t('insights'),
      nivel: 0,
      icon: 'svguse:#icon_insights',
      name: 'insights',
      href: `/${menu.slug}/insights`,
      show: true,
    },
    {
      title: t('evidences'),
      nivel: 0,
      icon: 'svguse:#icon_evidencias',
      name: 'evidencias',
      href: `/${menu.slug}/evidencias`,
      show: menu.exibir_evidencia_property,
    },
    {
      title: t('followUps'),
      nivel: 0,
      icon: 'svguse:#icon_acompanhamentos',
      name: 'acompanhamentos',
      href: `/${menu.slug}/acompanhamento_detalhes`,
      show: menu.exibir_acompanhamento,
    },
  ]
}
export default menuList
